import { push } from 'react-router-redux';

import * as AccountRepository from 'repositories/account';

import { AccountActionCreators } from 'actions/account';
import { FlashMessageActionCreators } from 'actions/flashMessage';
import { LayoutActionCreators } from 'actions/layout';
import { ROUTE_ACCOUNT_KYC_FINISH } from 'constants/app';
import { handleGenericApiError } from 'helper/error';
import { compress } from 'helper/image';
import { AccountKycUploadDocumentForm } from 'models/account';
import { Thunk } from 'models/redux';

export function registerProfile(formValue: AccountKycUploadDocumentForm): Thunk {
  return (dispatch, getState) => {
    dispatch(LayoutActionCreators.showLoading.create());

    dispatch(uploadNationalCardScan(formValue.nationalCardScan, () => {
      dispatch(uploadNationalCardSelfie(formValue.nationalCardSelfie, () => {
        AccountRepository.updateProfile(getState().accountState.tempAccountProfileForm)
          .then((updateProfileResponse) => {
            const newAccount = { ...getState().accountState.account, profile: { ...updateProfileResponse } };
            dispatch(AccountActionCreators.updateAccount.create(newAccount));

            dispatch(push(ROUTE_ACCOUNT_KYC_FINISH));
            dispatch(LayoutActionCreators.hideLoading.create());
          })
          .catch((e) => {
            handleGenericApiError('action.failed.profile.register', e, dispatch);
            dispatch(LayoutActionCreators.hideLoading.create());
            console.error(e); // tslint:disable-line
          });
      }));
    }));
  };
}

export function uploadNationalCardScan(nationalCardScan: File, successCallback: () => void): Thunk {
  return (dispatch, getState) => {
    compress(
      nationalCardScan,
      (compressResult) => {
        AccountRepository.uploadNationalCardScan(compressResult)
          .then(() => successCallback())
          .catch((e) => {
            handleGenericApiError('action.failed.profile.upload.nationalCardScan', e, dispatch);
            dispatch(LayoutActionCreators.hideLoading.create());
            console.error(e); // tslint:disable-line
          });
      },
      (e) => {
        dispatch(FlashMessageActionCreators.show.create({
          modifier: 'danger',
          text: 'action.failed.profile.upload.nationalCardScan'
        }));
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      }
    );
  };
}

export function uploadNationalCardSelfie(nationalCardSelfie: File, successCallback: () => void): Thunk {
  return (dispatch, getState) => {
    compress(
      nationalCardSelfie,
      (compressResult) => {
        AccountRepository.uploadNationalCardSelfie(compressResult)
          .then(() => successCallback())
          .catch((e) => {
            handleGenericApiError('action.failed.profile.upload.nationalCardSelfie', e, dispatch);
            dispatch(LayoutActionCreators.hideLoading.create());
            console.error(e); // tslint:disable-line
          });
      },
      (e) => {
        dispatch(FlashMessageActionCreators.show.create({
          modifier: 'danger',
          text: 'action.failed.profile.upload.nationalCardSelfie'
        }));
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      }
    );
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/account/profile.ts